import React, { useContext } from "react";
import CheckoutLogo from "./ImagesUpload/CheckoutLogo";
import AuthContext from "../../../../contexts/AuthContext";
import RichTextEditor from "../../../../revampComponents/RichTextEditor";
import { dashboardColors, theme } from "../../../../themes/Theme";


const CheckoutPageAccordian = ({ eventDetails, formik, isRestricted = false }) => {
	const { user } = useContext(AuthContext);
	const isKonfHubUser = true;
	const eventTemplate = eventDetails.event_template;
	const updateContent = async contentUpdate => {
		formik.setFieldValue("checkout_consent", contentUpdate);
	};

	const htmlContent =
		formik.values.checkout_consent !== null ? `${formik.values.checkout_consent}` : "";

	const newLinkColor = eventTemplate == 1 ? "#fdb14b" : eventTemplate == 2 ? "#FB5850" : "";

	// Use a regular expression to match all <a> tags and add a style attribute to change the color
	const modifiedHtmlContent = htmlContent.replace(
		/<a\b[^>]*>/g, // Regex to match all <a> tags
		`<a style="color: ${newLinkColor}; textDecoration: none; cursor: pointer;">`
	);

	return (
		<>
			<div className="row">
				<div className="col-md-7 d-flex flex-column justify-content-center">
					<p className="label mb-0">Checkout Page Logo</p>
					<p className="description-text mb-0 mt-2">
						Checkout page logo will be displayed in the footer of registration checkout
						page.
					</p>
					<p className="description-text mt-2">(Recommended dimension is 2:1)</p>
				</div>
				<div className="col-md-5">
					<CheckoutLogo formik={formik} isRestricted={isRestricted} />
				</div>
			</div>
			<div className="row">
				<div className="col-md-12 d-flex flex-column justify-content-center">
					<p className="label mb-0">Terms & Conditions</p>
					<p className="description-text mb-0 mt-2">
						Tailor the Terms & Conditions displayed on the event checkout page to suit
						your needs.
					</p>
				</div>
				<div className="col-md-6 mt-3">
					<RichTextEditor
						value={formik.values.checkout_consent}
						onChangeContent={updateContent}
						placeholder="Please provide description for your community!"
						preset="standard"
						disabled={isRestricted}
					/>
				</div>
				<div className="col-md-6 mt-3">
					<div className="preview-box text-center">
						<div className="preview-text">
							<span className="text-center">Preview</span>
						</div>
						<div className="preview-content-div">
							<div className="preview-content">
								<div className="coupon-apply w-100 mt-2">
									<div className="position-relative d-inline">
										<input
											className="p-2 mb-1"
											readOnly
											placeholder="Enter Code"
										/>
										<button>
											<div>Apply</div>
										</button>
									</div>
								</div>
								<button className="proceed-btn mt-3">Proceed</button>
								<div
									className="text-left mt-3 checkout-consent-text"
									dangerouslySetInnerHTML={{ __html: modifiedHtmlContent }}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<style jsx>
				{`
					.preview-box {
						border: 1px solid #c3cddf;
						height: 300px;
						padding: 10px;
						// display: flex;
						// justify-content: center;
						border-radius: 5px;
						background: #d9d9d9;
						overflow: scroll;
					}
					.preview-text {
						position: sticky;
						top: -10px;
						background: #d9d9d9;
						transition: box-shadow 0.3s ease-in-out;
						padding: 10px;
						z-index: 1;
						font-family: Hind;
						font-size: 14px;
						font-weight: 500;
						line-height: 22px;
						color: ${dashboardColors[theme].primaryTextColor};
					}
					.preview-content-div {
						background: #fff;
						padding: 0 20px 20px;
						width: 80%;
						margin: -10px auto 0;
						z-index: 0;
					}
					.preview-content {
						background: ${eventTemplate == 2 ? " #D9D9D9" : "#f6f6fc"};
						padding: 0px 20px 20px;
						border-bottom-left-radius: 20px;
						border-bottom-right-radius: 20px;
					}
					.proceed-btn {
						border: none;
						background: ${eventTemplate == 1
						? "#fdb14b"
						: eventTemplate == 2
							? " #FB5850"
							: "#000"};
						border-radius: 2px;
						color: ${eventTemplate == 1
						? "black"
						: eventTemplate == 2
							? "#fff"
							: "#fff"};
						font-weight: 500;
						font-size: 15px;
						padding: 0.4rem 1.2rem;
						width: 100%;
						cursor: auto !important;
					}
					.coupon-apply div input {
						background: #fff;
						border-radius: 5px 0px 0px 5px;
						border: none;
						height: 45px;
						width: 70%;
						color: #000;
						font-size: 16px;
						cursor: auto;
					}
					.coupon-apply div input:focus {
						outline: none;
					}
					.coupon-apply div input::placeholder {
						font-style: normal;
						font-weight: normal;
						font-size: 16px;
						color: #999999;
					}
					.coupon-apply div input:focus::placeholder {
						color: #999999;
					}
					.coupon-apply div button {
						height: 45px;
						width: 30%;
						border-radius: 0px 5px 5px 0px;
						font-weight: 500;
						transition: 0.3s all;
						color: ${eventTemplate == 1
						? "#fdb14b"
						: eventTemplate == 2
							? " #fb5850"
							: "#000"};
						background: #ffffff;
						border: 2px solid
							${eventTemplate == 1
						? "#fdb14b"
						: eventTemplate == 2
							? "#fb5850"
							: "#000"};
						cursor: auto;
					}
					.checkout-consent-text {
						font-family: Prompt;
						font-size: 14px;
						font-weight: 400;
						color: #495057;
						word-wrap: break-word;
					}
				`}
			</style>
		</>
	);
};

export default CheckoutPageAccordian;
